export const ADMIN_SCOPE = 'warehouse.admin';
export const DELETE_SCOPE = 'warehouse.delete';

function decodeJwtPayload(token: string): Record<string, unknown> | null {
	const parts = token.split('.');
	if (parts.length < 2) return null;
	try {
		const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
		return JSON.parse(atob(base64));
	} catch {
		return null;
	}
}

export function getScopesFromAccessToken(token: string | null | undefined): string[] {
	if (!token) return [];
	const payload = decodeJwtPayload(token);
	if (!payload) return [];

	const scopes = new Set<string>();
	if (typeof payload.scope === 'string') {
		payload.scope
			.split(' ')
			.filter(Boolean)
			.forEach((scope) => scopes.add(scope));
	}
	if (Array.isArray(payload.permissions)) {
		payload.permissions
			.filter((permission): permission is string => typeof permission === 'string')
			.forEach((permission) => scopes.add(permission));
	}
	return [...scopes];
}

export function hasAdminScope(token: string | null | undefined): boolean {
	return getScopesFromAccessToken(token).includes(ADMIN_SCOPE);
}
